import React from 'react';
import { Box, Container, Grid, Typography, Link as MuiLink } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import InstagramIcon from '@mui/icons-material/Instagram';

const FooterContainer = styled(Box)({
  backgroundColor: '#1a1a1a',
  color: '#fff',
  padding: '4rem 0 2rem',
});

const FooterTitle = styled(Typography)({
  fontFamily: 'Cormorant Garamond, serif',
  fontSize: '1.2rem',
  marginBottom: '1.5rem',
  color: '#c4a661',
  letterSpacing: '1px',
});

const FooterLink = styled(Link)({
  color: '#999',
  textDecoration: 'none',
  fontSize: '0.9rem',
  display: 'block',
  marginBottom: '0.75rem',
  transition: 'color 0.3s ease',
  fontFamily: 'Cormorant Garamond, serif',
  '&:hover': {
    color: '#fff',
  },
});

const FooterText = styled(Typography)({
  color: '#999',
  fontSize: '0.9rem',
  marginBottom: '0.75rem',
  fontFamily: 'Cormorant Garamond, serif',
});

const SocialContainer = styled(Box)({
  display: 'flex',
  gap: '1.5rem',
  marginTop: '2rem',
});

const SocialIcon = styled(MuiLink)({
  color: '#999',
  '&:hover': {
    color: '#fff',
  },
  '& .MuiSvgIcon-root': {
    fontSize: '1.5rem',
  },
});

const Footer = () => {
  return (
    <FooterContainer component="footer">
      <Container maxWidth="lg">
        <Grid container spacing={6}>
          <Grid item xs={12} sm={6} md={3}>
            <FooterTitle>About Us</FooterTitle>
            <FooterLink to="/our-story">Our Story</FooterLink>
           
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <FooterTitle>Customer Care</FooterTitle>
            <FooterLink to="/contact">Contact Us</FooterLink>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <FooterTitle>Visit Us</FooterTitle>
            <FooterText>Beverly Hills, CA 90210</FooterText>
            <FooterText>+1 (562) 677-6682</FooterText>
            <FooterText>
              customconnectjewelry@gmail.com
            </FooterText>
            <SocialContainer>
              <SocialIcon href="https://www.instagram.com/customconnectjewlery?igsh=NTc4MTIwNjQ2YQ==" target="_blank" rel="noopener">
                <InstagramIcon />
              </SocialIcon>
            </SocialContainer>
          </Grid>

        </Grid>
      </Container>
    </FooterContainer>
  );
};

export default Footer;
